import { RouteComponentProps } from 'react-router';
import { ComponentType } from 'react';
import withDatasetPageLayout from './withDatasetPageLayout';
import withDatasetScope from './withDatasetScope';

const withDatasetRoute = <P extends RouteComponentProps>(
  Component: ComponentType<P>
) =>
  // Keep dataset scope outermost while allowing route-specific layout behavior.
  withDatasetScope(withDatasetPageLayout(Component));

export default withDatasetRoute;
